/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './interactive-timeline.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/interactive-timeline/interactive-timeline.component';
const styles_InteractiveTimelineComponent:any[] = [i0.styles];
export const RenderType_InteractiveTimelineComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_InteractiveTimelineComponent,data:{}});
export function View_InteractiveTimelineComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{timelineEl:0}),(_l()(),i1.ɵeld(0,[[1,0],['timeline',
      1]],(null as any),0,'div',[['class','timeline']],(null as any),(null as any),
      (null as any),(null as any),(null as any)))],(null as any),(null as any));
}
export function View_InteractiveTimelineComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-interactive-timeline',
      ([] as any[]),(null as any),(null as any),(null as any),View_InteractiveTimelineComponent_0,
      RenderType_InteractiveTimelineComponent)),i1.ɵdid(114688,(null as any),0,i2.InteractiveTimelineComponent,
      [i1.ElementRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const InteractiveTimelineComponentNgFactory:i1.ComponentFactory<i2.InteractiveTimelineComponent> = i1.ɵccf('admin-interactive-timeline',
    i2.InteractiveTimelineComponent,View_InteractiveTimelineComponent_Host_0,{data:'data',
        height:'height'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2ludGVyYWN0aXZlLXRpbWVsaW5lL2ludGVyYWN0aXZlLXRpbWVsaW5lLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC9pbnRlcmFjdGl2ZS10aW1lbGluZS9pbnRlcmFjdGl2ZS10aW1lbGluZS5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC9pbnRlcmFjdGl2ZS10aW1lbGluZS9pbnRlcmFjdGl2ZS10aW1lbGluZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2ludGVyYWN0aXZlLXRpbWVsaW5lL2ludGVyYWN0aXZlLXRpbWVsaW5lLmNvbXBvbmVudC50cy5JbnRlcmFjdGl2ZVRpbWVsaW5lQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cInRpbWVsaW5lXCIgI3RpbWVsaW5lPjwvZGl2PiIsIjxhZG1pbi1pbnRlcmFjdGl2ZS10aW1lbGluZT48L2FkbWluLWludGVyYWN0aXZlLXRpbWVsaW5lPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozt3RENBQTtNQUFBO01BQUE7OztvQkNBQTtNQUFBOzZDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/interactive-timeline/interactive-timeline.component.ngfactory.ts